import {
  ChangeEvent,
  KeyboardEvent,
  MutableRefObject,
  useCallback,
  useMemo,
} from 'react';

import { Nullable } from '../../../../../types';
import { DatePatternInputProps } from '../../types/DatePatternInputProps';
import { getFormatFromDatePattern } from './logic/getFormatFromDatePattern';

export const useDatePattern = (
  _ref: DatePatternInputProps['_ref'],
  datePattern: DatePatternInputProps['datePattern'],
) => {
  const format = useMemo(
    () => getFormatFromDatePattern(datePattern),
    [datePattern],
  );

  const handleInputKeyDown = useCallback(
    (e: KeyboardEvent<HTMLInputElement>) => {
      const target = e.target as HTMLInputElement;
      const { value, selectionStart } = target;
      let sanitizedValue = value;
      if (datePattern === 'MM/YYYY') {
        if (e.key === '/' && value[selectionStart ?? 0] === '/') {
          // if there is number before slash with just one character add 0 prefix
          if (value.split('/')[0].length === 1) {
            sanitizedValue = `0${value}`;
            target.selectionStart! += 1;
          }

          target.selectionStart! += 1;
          e.preventDefault();
        }
      }
      target.value = sanitizedValue;
    },
    [datePattern],
  );

  const handleSetRef = useCallback(
    (el: Nullable<HTMLInputElement>) => {
      if (typeof _ref === 'function') {
        _ref(el);
      } else if (_ref) {
        // eslint-disable-next-line no-param-reassign
        (_ref as MutableRefObject<Nullable<HTMLInputElement>>).current = el;
      }
    },
    [_ref],
  );

  return {
    format,
    handleSetRef,
    handleInputKeyDown,
  };
};
